import apiWrapper, { getMethod, updateMethod } from './helpers'

export default class IssuedCardTransfer extends apiWrapper('/issued_card_transfers') {
  static balance = getMethod('/issued_card_transfers/balance')
  static approve = updateMethod('/issued_card_transfers', 'approve')
  static deny = updateMethod('/issued_card_transfers', 'deny')
}
